import Vue from "vue";
import VueLodash from "vue-lodash";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isMatch from "lodash/isMatch";
import forIn from "lodash/forIn";
import sumBy from "lodash/sumBy";
import orderBy from "lodash/orderBy";
import remove from "lodash/remove";
import find from "lodash/find";
import omit from "lodash/omit";
import join from "lodash/join";
import mapValues from "lodash/mapValues";
import intersection from "lodash/intersection";
import intersectionWith from "lodash/intersectionWith";
import matches from "lodash/matches";
import concat from "lodash/concat";
import differenceWith from "lodash/differenceWith";
import includes from "lodash/includes";
import reduce from "lodash/reduce";
import filter from "lodash/filter";
import pick from "lodash/pick";
import values from "lodash/values";
import chunk from "lodash/chunk";
import groupBy from "lodash/groupBy";
import mapKeys from "lodash/mapKeys";
import keys from "lodash/keys";
import transform from "lodash/transform";
import merge from "lodash/merge";
import map from "lodash/map";
import unionBy from "lodash/unionBy";
import keyBy from "lodash/keyBy";
import uniqBy from "lodash/uniqBy";

Vue.use(VueLodash, {
  lodash: {
    map,
    join,
    isEmpty,
    forEach,
    forIn,
    groupBy,
    mapValues,
    reduce,
    values,
    remove,
    find,
    intersection,
    intersectionWith,
    matches,
    isEqual,
    isMatch,
    concat,
    differenceWith,
    sumBy,
    orderBy,
    omit,
    includes,
    filter,
    pick,
    chunk,
    transform,
    mapKeys,
    keys,
    merge,
    unionBy,
    keyBy,
    uniqBy,
  },
});
